import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService } from '../commons/abstract.service';
import { PaymentLogging } from '../models/payment-logging.model';

@Injectable({ providedIn: 'root' })
export class PaymentLoggingService extends AbstractService<PaymentLogging> {

  getURLBase(): string {
    return '/payment/payment-logging';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: PaymentLogging): void {
    delete obj?._id;
  }
  preUpdate(obj: PaymentLogging): void {
  }

}  